export default __webpack_public_path__ + "static/media/notFound.bd7752df.svg";